"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconDone = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
/**
 * Локальная копия иконки Done, полная сборка
 */
var sizeMap = {
    xs: 1,
    s: 1.5,
};
var Done = function (props) { return (react_1.default.createElement("svg", __assign({ width: "100%", viewBox: "0 0 24 24", fill: "none" }, props),
    react_1.default.createElement("path", { d: "M9 16.2l-3.5-3.5a.984.984 0 00-1.4 0 .984.984 0 000 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7a.984.984 0 000-1.4.984.984 0 00-1.4 0L9 16.2z", fill: "currentColor" }))); };
var StyledRoot = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-flex;\n    ", "\n"], ["\n    display: inline-flex;\n    ",
    "\n"])), function (_a) {
    var w = _a.w;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: ", ";\n        height: ", ";\n    "], ["\n        width: ", ";\n        height: ", ";\n    "])), w, w);
});
exports.IconDone = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 's' : _b, color = _a.color, className = _a.className;
    return (react_1.default.createElement(StyledRoot, { w: sizeMap[size] + "rem", className: className },
        react_1.default.createElement(Done, { color: color, size: size })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=IconDone.js.map